module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAABGdBTUEAALGPC/xhBQAAALVJREFUSA3V010KgzAQBGD74FkKXsNLerm+9gi+xpmQhbD+1Lij0IUlkYT5YiBd92+VUnqzHz13Qb8Y2c/gFYpprvtxMLxeQr7uwyHtoXYIPX4C1eMH6IQ1tq/4nyNx73oJvkpr8V+ovV8pfhaV4q2oBL+KhvAoeglXoU040B79QfvKT8bCWkeE8bltPTVafc7DZETPaKsQaodEmMdpjLbucQlq4RW+RqtNAzfat2os+KDKC+UsW9D9EfdkdC0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/arrow-up.png
// module id = 585
// module chunks = 35783957827783